import React from 'react';
import { Provider } from 'react-redux';
import './App.css';
import Store from './store/Store';
import { Container } from 'react-bootstrap';
import { Route, Routes, BrowserRouter as Router, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import QuizSelectionPage from './pages/QuizSelectionPage';
import QuizPage from './pages/QuizPage';
import QuizResultsPage from './pages/QuizResultsPage';
import GuidePage from './pages/GuidePage';
import FattiesProjectPage from './pages/FattiesProjectPage';
import BlogListPage from './pages/blog/BlogListPage';
import BlogPostPage from './pages/blog/BlogPostPage';
import ResumePage from './pages/ResumePage';
import NavigationWrapper from './components/NavigationWrapper';
import LocaleFromUrl from './components/LocaleFromUrl';
import { LocaleProvider } from './context/LocaleContext';

const AppContent: React.FC = () => {
  return (
    <LocaleProvider>
    <NavigationWrapper>
      <div className="App">
        <Container style={{ maxWidth: "100%", padding: 0 }}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/blog" element={<BlogListPage />} />
            <Route path="/blog/:id" element={<BlogPostPage />} />
            <Route path="/resume" element={<ResumePage />} />
            <Route path="/:locale" element={<LocaleFromUrl />}>
              <Route index element={<HomePage />} />
              <Route path="blog" element={<BlogListPage />} />
              <Route path="blog/:id" element={<BlogPostPage />} />
              <Route path="resume" element={<ResumePage />} />
            </Route>
            <Route path="/projects/vejen-til-dansk-statsborgerskab" element={<QuizSelectionPage />} />
            <Route path="/projects/vejen-til-dansk-statsborgerskab/start" element={<QuizPage />} />
            <Route path="/projects/vejen-til-dansk-statsborgerskab/resulter" element={<QuizResultsPage />} />
            <Route path="/projects/fatties-nft-platform" element={<FattiesProjectPage />} />
            <Route path="/guider" element={<GuidePage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Container>
      </div>
    </NavigationWrapper>
    </LocaleProvider>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <Provider store={Store}>
        <AppContent />
      </Provider>
    </Router>
  );
}

export default App;
